import {
    Dropdown,
    DropdownButtonNew as DropdownButton,
    DropdownContent,
} from 'components/Dropdown'
import {
    HeroCheckCircleIcon,
    HeroUserMinusIcon,
} from 'components/Icon'
import {
    styledButton,
    styledContent,
    styledList,
    styledName,
} from 'components/Sidebar/styles'
import AssignTranscriptPromiseModal from 'components/Modal/AssignTranscriptPromiseModal'
import Button from 'components/Button'
import {Icon} from 'components/Icon/types'
import QueueingTimeView from 'components/QueueingTime'
import React from 'react'
import SetTranscriptStatusPromiseModal from 'components/Modal/SetTranscriptStatusPromiseModal'
import {SidebarTranscriptViewProps} from './types'
import TicketAvatar from 'components/Avatar/TicketAvatar'
import {getActiveQueueSettings} from 'utils/queueSettings'
import {styled} from 'stitches/config'
import {styledItem} from 'components/Dropdown/styles'
import {useAppSelector} from 'hooks'
import {usePromiseModal} from 'components/Modal/PromiseModal/hooks/usePromiseModal'
import {useTranslation} from 'react-i18next'

const StyledList = styled('li', styledList)
const StyledContent = styled('div', styledContent)
const StyledButton = styled('button', styledButton)
const StyledName = styled('div', styledName)
const StyledItem = styled('div', styledItem)

const SidebarTranscriptView = (props: SidebarTranscriptViewProps): React.ReactElement => {
    const {
        isSelected,
        loadTranscript,
        onMarkTranscriptAsDone,
        onUnassignTranscript,
        parentQueueSettings,
        transcript,
    } = props

    const {t} = useTranslation()

    const sessionUserId = useAppSelector(({ninchat}) => ninchat.user_id)
    const transcriptQueue = useAppSelector(({ninchat}) => ninchat.user_queues?.[transcript.queue_id] ?? ninchat._queues?.[transcript.queue_id])
    const queueSettings = getActiveQueueSettings({
        parentGroupQueue: parentQueueSettings ? {queue_settings: parentQueueSettings} : undefined,
        queue: transcriptQueue,
    })

    const openAssignTranscriptModal = usePromiseModal<string>(AssignTranscriptPromiseModal, {instanceId: 'assignTranscript'})
    const openSetTranscriptStatusModal = usePromiseModal(SetTranscriptStatusPromiseModal, {instanceId: 'setTranscriptStatus'})

    const onMarkAsDone = () => {
        openSetTranscriptStatusModal({}).then(
            () => {
                onMarkTranscriptAsDone(transcript.audience_id)
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => {},
        )
    }

    const onUnassign = () => {
        if (sessionUserId) {
            openAssignTranscriptModal({}).then(
                (reason) => {
                    onUnassignTranscript(transcript.audience_id, sessionUserId, reason)
                },
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                () => {},
            )
        }
    }

    return (
        <StyledList nested={true}>
            <StyledContent>
                <StyledButton
                    active={isSelected}
                    onClick={() => loadTranscript()}
                    type='button'
                >
                    <TicketAvatar
                        name={t('Ticket')}
                        size='small'
                    />
                    <StyledName>
                        <div>{t('Ticket')}</div>
                    </StyledName>
                    {transcript.complete_time ?
                        <QueueingTimeView
                            queueLength={1}
                            queue_time={transcript.complete_time}
                            sla={queueSettings?.ticket_sla}
                            slaReminderTime={queueSettings?.ticket_sla_reminder_time}
                            slaWarningTime={queueSettings?.ticket_sla_warning_time}
                        />
                        : null}
                </StyledButton>
                <Dropdown>
                    <DropdownButton caret={true} color='text' data-id='dropdown-caret' size='small' />
                    <DropdownContent direction='fixed-end'>
                        <StyledItem>
                            <Button
                                color='text'
                                iconLeft={HeroUserMinusIcon as unknown as Icon}
                                onPress={(): void => onUnassign()}
                                text={t('Unassign')}
                                title={t('Unassign')}
                                type='button'
                            />
                            <Button
                                color='text'
                                iconLeft={HeroCheckCircleIcon as unknown as Icon}
                                onPress={(): void => onMarkAsDone()}
                                text={t('Mark as done and close')}
                                title={t('Mark as done and close')}
                                type='button'
                            />
                        </StyledItem>
                    </DropdownContent>
                </Dropdown>
            </StyledContent>
        </StyledList>
    )
}

export default SidebarTranscriptView
